<template>
  <div>
    <MovieBlockedContainer
      v-if="post.component === 'movie'"
      :movie="post"
      :model="model"
      :imgStyle="imgStyle"
      :getImageBackgroundUrl="getImageBackgroundUrl"
      :cssVars="cssVars"
      :link="link"
    />
    <PictureBlockedContainer
      v-else-if="post.component === 'picture'"
      :picture="post"
      :model="model"
      :imgStyle="imgStyle"
      :getImageBackgroundUrl="getImageBackgroundUrl"
      :cssVars="cssVars"
      :link="link"
    />
    <div v-else>
      {{$t('video_watch.not_available')}}
    </div>
  </div>

</template>
<script>
import MovieBlockedContainer from "../PostContainer/MovieBlockedContainer"
import PictureBlockedContainer from "../PostContainer/PictureBlockedContainer"

export default {
  name: 'PostBlockedContainer',
  components: {MovieBlockedContainer, PictureBlockedContainer},
  props: {
    post: {},
    model: {}
  },
  
  computed: {
    imgStyle(){
      let image = this.post.public_thumbnail_image_path['small'];
      
      return {
        backgroundImage: `url('${image}')`
      };
    },
    getImageBackgroundUrl(){
      return (this.post.front_container === 'normal')
        ? this.post.public_thumbnail_image_path['small']
        : `/img/posts/${this.post.front_container}.png`;
    },
    cssVars() {
      return {
        '--background': `url('${this.getImageBackgroundUrl}')`,
      }
    },
    link() {
      if (this.post.front_container === 'free')    return {name: 'singup'}
      if (this.post.front_container === 'premium') return {name: 'subscribe', query: {webstar: this.model.username}}
      if (this.post.front_container === 'normal')  return {name: 'subscribe', query: {webstar: this.model.username}}
    },
  }



}
</script>